import React from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import BaseComponent from '../../../../baseClasses/BaseComponent'; 
import DataSource from '../../../../dao/DataSource/DataSource';
import CollectionDataSource from '../../../../dao/DataSource/CollectionDataSource';
import PORProjectChildCard from '../PORProjectChildCard';
import './PORLocationParentCard.scss';
import anime from 'animejs';

// TODO: reduce complexity in this component
class PORLocationParentCard extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = { 
    };

    this.expandCard = this.expandCard.bind(this);
    this.collapseCard = this.collapseCard.bind(this);
    this.createProjectCards = this.createProjectCards.bind(this);
  }
  
  handleLocationRetrieval(location, action, acData, fetchedData) {
    if (location && (!acData || acData.type != 'deleteLocation')) {
      this.setState({ location });
    }
  }

  handleProjectsRetrieval(projects, action, acData, fetchedData) {
    this.setState({ projects: projects.projects, expanded: true }, () => {
      // this.expandCard()
    });
  }

  componentDidMount() {
    super.componentDidMount(this);

    this.locationDataSource = new DataSource('Location', this.props.location.id, { location: {} }, this.handleLocationRetrieval);
    this.locationDataSource.get();

    this.projectsDataSource = new CollectionDataSource('LocationProjectsCollection', 'Project', { projects: {} }, this.handleProjectsRetrieval,
      'LocationProjects', null, this.props.location.id,
      this.props.currentUser.id, null, null);
    
    if (this.props.expanded) {
      this.projectsDataSource.current(null, null, true);
    }
  }

  componentWillUnmount() {
    if (this.locationDataSource) {
      this.locationDataSource.release();
      this.locationDataSource = null;
    }
    if (this.projectsDataSource) {
      this.projectsDataSource.release();
      this.projectsDataSource = null;
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.filter != this.props.filter) {
      if (this.projectsDataSource) {
        this.projectsDataSource.filter = this.props.filter;
        this.projectsDataSource.current(null, null, true);
      }
    }
  }

  handleSelectProject(project) {
    if (this.props.selectProject) {
      this.props.selectProject(project, this.state.location);
    }
  }

  handleLocationSelection(select, ignoreSelection) {
    const { selectLocation } = this.props;
    const { location } = this.state;
    if (selectLocation && !ignoreSelection) {
      selectLocation(location);
    }
  }

  handleLocationExpandContract() {
    if (this.state.expanded) {
      this.setState({ expanded: false });
    }
    else {
      this.projectsDataSource.current(null, null, true);
    }
  }

  createProjectCards() {
    const { projects, location } = this.state;

    if (projects) {
      projects.sort((p1, p2) => {
        return p1.name < p2.name ? -1 : p1.name > p2.name ? 1 : 0;
      });
      return projects.map(project => {
        let digest = 'por-project-child-card-' + location.id + '-' + project.id;
        return <PORProjectChildCard id={digest} project={project} key={digest} selectProject={this.handleSelectProject}
          selected={this.props.selectedProjectId == project.id}/>;
      });
    }
  }

  expandCard() {
    const height = this.state.projects ? (this.state.projects.length * 64) : 64;
    return anime({
      targets: this.card,
      height: height,
      easing: 'easeInOutCubic',
      duration: 1000,
      complete: () => {
        this.setState({ expanded: true });
      },
    });
  }

  collapseCard() {
    this.setState({ collapsing: true });
    return anime({
      targets: this.card,
      height: 0,
      easing: 'easeInOutCubic',
      duration: 1000,
      complete: () => {
        this.setState({ expanded: false, collapsing: false });
      },
    });
  }
  
  handleEditLocation(e) {
    e.stopPropagation();
    if (this.props.editLocation) {
      this.props.editLocation(this.state.location);
    }
  }

  render() {
    let { selected, permissions } = this.props;

    let { location, expanded } = this.state;
    if (!location) {
      return null;
    }

    const canEdit = permissions.isSuperUser || permissions.canEditLocation;
    
    let projectCards = this.createProjectCards();
    return (
      <div
        key={'por-location-parent-card-' + location.id}
        id={this.props.id}
        className={'por-location-parent-card-outer ' + (expanded ? ' expanded' : '')}>
        <div className={'por-location-parent-card ' + (selected ? ' selected' : '')}
          onClick={this.handleLocationSelection}
        >
          <div className="location-parent-box">
            <div className="location-parent-info">
              <div className="location-parent-name">
                {location.name.toUpperCase()}
              </div>
              {location.address ?
                (<div className="location-parent-address">
                  {location.address}
                </div>) : null
              }
              <div className="location-parent-id">
                {'ID: ' + location.guid}
              </div>
            </div>
            {canEdit ? <div className={'location-parent-edit'} onClick={this.handleEditLocation} /> : null}
            <div className={'location-parent-expand-collapse' + (expanded ? ' expanded' : '')} onClick={this.handleLocationExpandContract}/>
          </div>
          </div>
          <div className={'por-projects' + (expanded ? ' expanded' : '')}
            ref={el => this.card = el}
          >
            {projectCards}
          </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    permissions: state.new_users.permissions,
    currentUser: state.new_users.currentUser,
    currentCompany: state.new_companies.currentCompany,
  };
};

export default connect(mapStateToProps)(PORLocationParentCard);



// WEBPACK FOOTER //
// ./src/containers/PORContainer/PORNav/PORLocationParentCard/index.js